import { Component } from "vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";
import { CustomReportHelpContentType } from "../models/CustomReportHelpContentType";



export class CustomReportHelpContentFactory extends HelpContentFactory<CustomReportHelpContentType> {

    public cdnContentPath: string = "custom_reports";

    public async tryGetStaticHelpContentByType(type: CustomReportHelpContentType | string): Promise<Component | null> {
        switch (type) {
            case CustomReportHelpContentType.Default:
            default:
                return null;
        }
    }

}